module.exports = __webpack_public_path__ + "img/pauli-z-root-18.617497b7.svg";